import { InputTag } from 'mixs/base/input_mixin';
export class Input extends InputTag {
}

riot.mixin('inputs.checkbox-fade-in', Input as riot.TagMixin)
